import React from 'react';
import { ScrollArea as ShadcnScrollArea } from '../shadcn/scroll-area';

const ScrollAreaInner = ({ children }: React.PropsWithChildren<{}>) => (
  <ShadcnScrollArea
    className="h-full w-full mr-[2px] rounded-none"
    scrollHideDelay={200}
    orientation="both"
    viewportClassName="rounded-none [&>div]:!block [&>div]:!min-w-0"
    scrollbarClassName="border-0 p-0 mr-[2px] data-[orientation=vertical]:w-[5px] data-[orientation=horizontal]:h-[5px]"
    // content-light at 50% alpha — kept in sync with the global native scrollbar colour in
    // apps/web/public/globals.css so native and custom scrollbars share one subtle resting tone.
    thumbClassName="rounded-radius-lg bg-content-light/50">
    {children}
  </ShadcnScrollArea>
);

ScrollAreaInner.displayName = 'ScrollArea';

const ScrollArea = React.memo(ScrollAreaInner);

export { ScrollArea };
